import * as t from "io-ts";

export const IntroductionState = t.union([
  t.literal("consumer_sent"),
  t.literal("consumer_viewed"),
  t.literal("consumer_agreed"),
  t.literal("consumer_details_provided"),
  t.literal("consumer_budgets_set"),
  t.literal("consumer_rejected"),
  t.literal("consumer_is_accepted"),
  t.literal("consumer_is_declined"),
  t.literal("job_details_provided"),
  t.literal("job_details_amended"),
  t.literal("trader_sent"),
  t.literal("trader_viewed"),
  t.literal("trader_agreed"),
  t.literal("trader_agreed_amended"),
  t.literal("trader_contact_provided"),
  t.literal("trader_details_provided"),
  t.literal("trader_rejected"),
  t.literal("trader_is_reviewed"),
  t.literal("trader_is_verified"),
  t.literal("trader_is_declined"),
  t.literal("job_converted"),
]);

export type IntroductionState =
  | "consumer_sent"
  | "consumer_viewed"
  | "consumer_agreed"
  | "consumer_details_provided"
  | "consumer_budgets_set"
  | "consumer_rejected"
  | "consumer_is_accepted"
  | "consumer_is_declined"
  | "job_details_provided"
  | "job_details_amended"
  | "trader_sent"
  | "trader_viewed"
  | "trader_agreed"
  | "trader_agreed_amended"
  | "trader_contact_provided"
  | "trader_details_provided"
  | "trader_rejected"
  | "trader_is_reviewed"
  | "trader_is_verified"
  | "trader_is_declined"
  | "job_converted";
